import { Page } from '@/core/architecture'

import { LotteryApplicationDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * LotteryApplicationDetail Page
 * Implemented as a practical sample.
 */
export const LotteryApplicationDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <LotteryApplicationDetailTemplate state={state} {...actions} />
}
